export class Api {
  static async uploadThumbnail(sequenceId, sequenceType = "sequence") {
    return post(`${sequenceType}/${sequenceId}/upload-thumbnail`);
  }

  static async syncVideoMetadata(sequenceId, sequenceType = "sequence") {
    return post(`${sequenceType}/${sequenceId}/sync-video-metadata`);
  }

  static async addAdvertising(sequenceId) {
    return post(`sequence/${sequenceId}/advertising`);
  }

  static async syncVideos(sequenceType) {
    return post(`${sequenceType}/sync`);
  }

	static async getSequenceTracks(sequenceId, sequenceType, {
		isNormalized = false,
		quality = 'default',
		isProduction = false,
	}) {
		return get(
				`${sequenceType}/${sequenceId}/tracks`,
				{isNormalized: isNormalized,
					quality: quality,
					isProduction: isProduction,
				},
		);
	}

  static async exportRadioTracks(sequenceId) {
    return post(`tracks-list/${sequenceId}/export`);
  }

	static async exportAllTracksLists() {
		return post(`tracks-list/export-all`);
	}

	static async getTrackUploadingStatus(trackId) {
		const data = await get(`track/${trackId}/uploading-status`);

		return data.status;
	}

	static async getTracks(trackIds, sequenceId=null) {
		const data = {
			ids: trackIds,
		}

		if (sequenceId) {
			data.sequenceId = sequenceId;
		}

		return get(
			`track`,
			data
		);
	}

	static async duplicateSequence(sequenceId, sequenceType) {
		try {
			const data = await post(`${sequenceType}/${sequenceId}/duplicate`);

			return data.redirectUrl;
		} catch (e) {
			throw new Error(e.message);
		}
	}

	static async updateTrack(trackId, data) {
		let body = [];

		for (const [key, value] of Object.entries(data)) {
			body.push({[key]: value});
		}

		return post(`track/${trackId}/update`, body);
	}

	static async updateSequence(sequenceId, data) {
		let body = [];

		for (const [key, value] of Object.entries(data)) {
			body.push({[key]: value});
		}

		return post(`sequence/${sequenceId}/update`, body);
	}

	static async generateTimecodes(sequenceId, loopDuration) {
		return get(`sequence/generate-timecodes`, {
			id: sequenceId,
			loopDuration: loopDuration,
		});
	}

	static async updateTrackFades(sequenceId, trackId, data) {
		let body = [];

		for (const [key, value] of Object.entries(data)) {
			body.push({[key]: value});
		}

		return post(`sequence/${sequenceId}/track/${trackId}/fades`, body);
	}

	static async deleteTrack(trackId) {
		return post(`track/${trackId}/delete`);
	}

	static async deleteSequence(sequenceId) {
		return post(`sequence/${sequenceId}/delete`);
	}

	static async getPlaylistLastProcessedTrack(playlistId) {
		const data = await get(`playlist/${playlistId}/last-processed-track`);
		return data.trackId;
	}

	static async updatePlaylistLastProcessedTrack(playlistId, trackId) {
		return post(`playlist/${playlistId}/last-processed-track`, [{trackId: trackId}]);
	}

	static async getPlaylistDividers(playlistId) {
		return get(`playlist/${playlistId}/dividers`, []);
	}

	static async updateDivider(dividerId, data) {
		return post(`divider/${dividerId}/update`, data);
	}

	static async deleteDivider(dividerId) {
		return post(`divider/${dividerId}/delete`);
	}

	static async createDivider(playlistId, position) {
		return post(`playlist/${playlistId}/dividers`, [{position: position}]);
	}

	static async startStream(streamId) {
		return post(`stream/${streamId}/start`);
	}

	static async stopStream(streamId) {
		return post(`stream/${streamId}/stop`);
	}

	static async getStreamUrl(streamId, isPreview) {
		const params = isPreview ? {is_preview: isPreview} : {};
	  	const data = await get(`stream/${streamId}/url`, params, true);

		return data.url;
	}

	static async getStreamStatus(streamId) {
		return await get(`stream/${streamId}/status`, {}, false);
	}

	static async sendFormField(action, csrfToken, name, value) {
		const loading = document.getElementById("infscr-loading");
		loading.classList.add("show");

		const fd = new FormData();

		fd.append("_csrf", csrfToken);

		if (value instanceof Array && value.length > 0) {
			value.forEach(val => { fd.append(name, val) });
		} else {
			fd.append(name, value);
		}
		const response = await fetch(action, {
			method: "POST",
			body: fd,
		});

		const responseData = await response.json();

		loading.classList.remove("show");

		if (response.ok) {
			return responseData;
		} else {
			throw new Error(
					Object.values(responseData.error)[0][0] ?? responseData.message ?? response.statusText
			);
		}
	}
}

async function get(url, data, isShowLoading = false) {
	let loading = null;
	if (isShowLoading) {
		loading = document.getElementById("infscr-loading");
		loading.classList.add("show");
	}

  if (data) {
		const queryParams = new URLSearchParams();

		for (let key of Object.keys(data)) {
			if (data[key] instanceof Array) {
				data[key].forEach(value => queryParams.append(key + '[]', value));
				continue;
			}

			queryParams.append(key, data[key]);
		}

	  url = url + "?" + queryParams;
  }

  const response = await fetch("/api/" + url, {
	  method: "GET",
	  headers: {
		  "content-type": "application/json",
		  "accept": "application/json"
	  },
  });
  const responseData = await response.json();


	if (isShowLoading) {
		loading?.classList.remove("show");
	}

  if (response.ok) {
    return responseData.hasOwnProperty("data") ? responseData.data : responseData;
  } else {
    throw Error(
      responseData.error || responseData.message || response.statusText
    );
  }
}

async function post(url, data = []) {
  const loading = document.getElementById("infscr-loading");
  loading.classList.add("show");

	const body = {};

	data.forEach(elem => {
		const field = Object.keys(elem)[0];
		body[field] = elem[field];
	});

  const response = await fetch("/api/" + url, {
    method: "POST",
	  headers: {
		"content-type": "application/json",
	  	"accept": "application/json"
	  },
    body: JSON.stringify(body),
  });

  const responseData = await response.json();

  loading.classList.remove("show");

  if (response.ok) {
    return responseData;
  } else {
    throw new Error(
		    responseData.error ?? responseData.message ?? response.statusText
    );
  }
}
